import React from 'react';
import logo from './logo.svg';
import './App.scss';
import {HashRouter, Route, Switch,Redirect } from 'react-router-dom';
import Login from '../src/page/login/login'
import TopHome from '../src/page/TopHome/TopHome'
import Contenthome from '../src/page/conentHome/contenthome'
function App() {
  return (
    <div className="App">
      <HashRouter>
        <Switch>
            <Route exact path="/login" component={Login}/>
            <Route exact path="/TopHome" component={TopHome}/>
            <Route path="/msite" component={Contenthome}/>
            <Redirect to="/login" from="/" />
        </Switch>
      </HashRouter>
    </div>
  );
}

export default App;
